import {context} from '../../../props/context'
import DesignerMixin from '../../../designer/mixins'

export default {
  name: 're-blank-component',
  mixins: [DesignerMixin],
  props: {
    context
  }
}
